module.exports = __webpack_public_path__ + "img/star-christmas.e510297e.svg";